export default class ResetPasswordRequest{
  public constructor(
    public email: string,
    public token: string,
    public password: string
  ){}
}
